import React, { useEffect, useState } from 'react';
import { TextField, CircularProgress, MenuItem } from '@mui/material';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getBaseCodes } from '../../../../modules/auth';

const TechCostTyp = ({
    index,
    formik,
    touched,
    errored,
    fieldName = 'rsltCosts',
    name,
    label,
    filterObject,
    variant,
    margin,
    disabled = false,
}) => {
    const [options, setOptions] = useState([]);

    const dispatch = useDispatch();
    const { baseCodes, error, loading } = useSelector(
        ({ auth, loading }) => ({
            baseCodes: auth.baseCodes,
            error: auth.baseCodesError,
            loading: loading['auth/GET_BASECODES'],
        }),
    );

    useEffect(() => {
        if (!baseCodes) {
            dispatch(getBaseCodes());
        } else {
            const filteredList = _.filter(baseCodes, filterObject);
            //console.log(filterObject,filteredList)
            setOptions(filteredList);
        }
    }, [dispatch, baseCodes])


    if (loading || !baseCodes) {
        return <CircularProgress color="inherit" size={20} />;
    }

    return (
        <>
            {options.length > 0 ? (
                <TextField

                    margin={margin !== null ? margin : ''}
                    variant={variant !== null ? variant : 'outlined'}
                    required
                    fullWidth
                    select
                    id={name}
                    name={name}
                    label={label}
                    value={formik.values?.[fieldName]?.[index]?.[name] ? formik.values[fieldName][index][name] : ''}
                    onChange={(event, newValue) => {
                        formik.setFieldValue(`${fieldName}.${index}.${name}`, event.target.value)
                    }}
                    helperText={touched && errored ? errored : ""}
                    error={Boolean(touched && errored)}
                    disabled={disabled}
                >
                    {options &&
                        options.map((option) => (
                            <MenuItem key={option.revVal2} value={option.revVal2}>
                                {option.revVal1}
                            </MenuItem>
                        ))}
                </TextField>
            ) : (
                <>
                    <React.Fragment>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    </React.Fragment>
                </>
            )}
        </>
    );
};

export default React.memo(TechCostTyp);
